import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { IoArrowBack, IoDocumentTextOutline } from 'react-icons/io5';
import { useLanguage } from './contexts/LanguageContext';
import './TermsPage.css';

function TermsPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="legal-container">
      <div className="legal-header">
        <button className="back-button" onClick={handleBack}>
          <IoArrowBack size={20} />
          {t('back')}
        </button>
        <div className="header-content">
          <IoDocumentTextOutline size={48} style={{ marginBottom: '12px', opacity: 0.9 }} />
          <h1>{t('termsTitle')}</h1>
          <p>{t('termsLastUpdated')}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="legal-card">

          <section className="legal-section">
            <h2>{t('termsAcceptTitle')}</h2>
            <p>{t('termsAcceptText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsServiceTitle')}</h2>
            <p>{t('termsServiceText')}</p>
            <ul>
              <li>{t('termsServiceMap')}</li>
              <li>{t('termsServiceWatch')}</li>
              <li>{t('termsServiceNotifs')}</li>
              <li>{t('termsServicePredict')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('termsAccountTitle')}</h2>
            <p>{t('termsAccountText')}</p>
            <ul>
              <li>{t('termsAccountAccurate')}</li>
              <li>{t('termsAccountSecure')}</li>
              <li>{t('termsAccountResponsible')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('termsSubTitle')}</h2>

            <h3>{t('termsSubFreeTitle')}</h3>
            <p>{t('termsSubFreeText')}</p>

            <h3>{t('termsSubProTitle')}</h3>
            <p>{t('termsSubProText')}</p>

            <h3>{t('termsSubAutoTitle')}</h3>
            <p>{t('termsSubAutoText')}</p>

            <h3>{t('termsSubCancelTitle')}</h3>
            <p>{t('termsSubCancelText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsDisclaimerTitle')}</h2>
            <p>{t('termsDisclaimerText')}</p>
            <ul>
              <li>{t('termsDisclaimerAccuracy')}</li>
              <li>{t('termsDisclaimerDelay')}</li>
              <li>{t('termsDisclaimerPredict')}</li>
              <li>{t('termsDisclaimerAffiliate')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('termsUseTitle')}</h2>
            <p>{t('termsUseText')}</p>
            <ul>
              <li>{t('termsUseNoReverse')}</li>
              <li>{t('termsUseNoAbuse')}</li>
              <li>{t('termsUseNoAutomate')}</li>
              <li>{t('termsUseNoResell')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('termsIpTitle')}</h2>
            <p>{t('termsIpText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsTerminationTitle')}</h2>
            <p>{t('termsTerminationText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsLiabilityTitle')}</h2>
            <p>{t('termsLiabilityText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsChangesTitle')}</h2>
            <p>{t('termsChangesText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsGoverningTitle')}</h2>
            <p>{t('termsGoverningText')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('termsContactTitle')}</h2>
            <p>{t('termsContactText')}</p>
            <p className="contact-email">support@noqueuecharge.com</p>
          </section>

          <div className="legal-cross-link">
            <Link to="/privacy">{t('termsViewPrivacy')}</Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default TermsPage;
